import { AppConfigType } from '@src/app/modules/app-config';

import { DownloadLinksComponentOptions } from '../types';

export const convertAppConfigToDownloadLinks = (data: AppConfigType): DownloadLinksComponentOptions => {
  return {
    androidDownloadLink: data.googlePlayLink,
    iosDownloadLink: data.appStoreLink,
  };
};
